import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";

const Tab = ({
  children,
  id,
  name,
  innerValue,
  currentValue,
  onChange,
  onClick,
}) => (
  <>
    <input
      type="radio"
      value={innerValue}
      checked={currentValue === innerValue}
      {...{ id, name, onChange }}
    />
    <label htmlFor={id} className={classes.Tab} onClick={onClick || null}>
      {children}
    </label>
  </>
);

Tab.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  innerValue: PropTypes.any,
  currentValue: PropTypes.any,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

const TabSelector = ({
  name,
  options,
  value: currentValue,
  onChange,
  className = "",
}) => (
  <div className={cl(classes.TabsWrapper, className, "tabs-wrapper")}>
    {Object.entries(options).map(([label, value], i) => (
      <Tab
        id={`${name}-${i}`}
        key={`${name}-${i}`}
        name={name}
        innerValue={value}
        currentValue={currentValue}
        onChange={() => onChange(value)}
      >
        {label}
      </Tab>
    ))}
  </div>
);

TabSelector.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  options: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TabSelector;
